import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { CardContent } from "components/cards";

function CardProject({ imageData, markdown }) {
  const { gatsbyImageData } = imageData.childrenImageSharp[0];
  const { title, excerpt, date, to, path } = markdown.frontmatter;

  return (
    <CardContent>
      <Link to={to || path}>
        <GatsbyImage
          image={gatsbyImageData}
          alt="images"
          style={{ objectFit: "cover" }}
        />
        <div className="p-8">
          <p className="text-md font-bold">{title}</p>
          <p className="text-sm gray-500 mb-2">{date}</p>
          <p className="text-sm text-gray-700 justify">{excerpt}</p>
        </div>
      </Link>
    </CardContent>
  );
}

CardProject.propTypes = {
  imageData: PropTypes.object.isRequired,
  markdown: PropTypes.object.isRequired,
};

export default CardProject;
